import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import Table from 'react-bootstrap/Table'
import { Link, useParams } from 'react-router-dom'
import Button from 'react-bootstrap/Button'
import axios from 'axios'

function RecordPage() {
  const token = useSelector((s) => s.login.token)
  const { id } = useParams()
  const [data, setData] = useState({})

  useEffect(() => {
    axios
      .get(`/en/special/api/getDeptApplicationDetail/${id}/${token}`)
      .then((res) => {
        if (res.data.status === 'OK') {
          // console.log(res.data.result.detail)
          setData(res.data.result.detail)
        } else {
          // console.log(res.data)
          alert(res.data.result)
        }
      })
      .catch((err) => {
        // console.log(err)
        alert('發生錯誤')
      })
  }, [token])

  return (
    <div className='container mb-5'>
      <div className='absolute-bg'></div>
      <h1 className='size-1 my-5 text-left text-sm-center'>申請紀錄詳情</h1>

      <Table striped variant='green' className='text-grey'>
        <tbody>
          <tr>
            <td className='font-weight-bold'>承辦人員</td>
            <td>{data.department_detail ? data.department_detail.name : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>學院</td>
            <td>{data.department_detail ? data.department_detail.degree : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>學系</td>
            <td>{data.department_detail ? data.department_detail.dept : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>信箱</td>
            <td>{data.department_detail ? data.department_detail.email : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>電話</td>
            <td>{data.department_detail ? data.department_detail.tel : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>學期</td>
            <td>{data.semester ? data.semester.title : ''}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>開始日期</td>
            <td>{data.start_date}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>結束日期</td>
            <td>{data.end_date}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>小老師姓名</td>
            <td>{data.tutor_name}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>申請金額</td>
            <td>{data.amount}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>輔導科目</td>
            <td>{data.subject}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>輔導規劃</td>
            <td>{data.plan}</td>
          </tr>
          <tr>
            <td className='font-weight-bold'>應徵資料表與成績單</td>
            <td>
              <a href={data.attachment} className='text-blue' target='_blank'>
                {data.attachment}
              </a>
            </td>
          </tr>
        </tbody>
      </Table>

      <div className='text-center mt-5'>
        <Link to='/special/apply-record'>
          <Button variant='orange'>回到申請列表</Button>
        </Link>
      </div>
    </div>
  )
}

export default RecordPage
